'use client';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getMenuSnapshot } from '@/app/(users)/totem-by-slug/[slug]/actions/get-menu-snapshot';
import type { MenuSnapshot } from '@/app/(users)/totem-by-slug/[slug]/types/menu-snapshot';
import { supabase } from '@/lib/supabase/client';

export function useTotemMenu(totemId: string, menuId: string | null | undefined) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['menu-snapshot', totemId, menuId],
    queryFn: () => getMenuSnapshot({ totemId, menuId: menuId! }),
    enabled: Boolean(totemId && menuId),
  });

  useEffect(() => {
    if (!menuId || !totemId) return;

    const channel = supabase
      .channel(`menu-version:${menuId}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'menus',
          filter: `id=eq.${menuId}`,
        },
        () => {
          queryClient.invalidateQueries({ queryKey: ['menu-snapshot', totemId, menuId] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [menuId, totemId, queryClient]);

  return {
    menu: query.data as MenuSnapshot | null | undefined,
    isLoading: query.isLoading,
    error: query.error,
  };
}
